import React from 'react';
import Hero from './home/Hero';
import About from './home/About';
import Features from './home/Features';
import OurActivity from "./home/Ouractivity";
import Address from './home/Address';

const Home = () => {
  return (
    <main>
      <Hero />
      <About />
      <Features />
      <OurActivity />
      <Address />
    </main>
  );
};

export default Home;